<section class="voting-configuration" aria-label="Voting configuration">
  <p *ngIf="integratedPopulation">The hearing panel supplies and confirms this step’s voters.</p>
  <p *ngIf="!integratedPopulation">
    Prepare identified voters, conduct a round, then evaluate its quorum result.
    These actions do not require an independent review.
  </p>
  @if (code === "voting.result") {
    <label
      >Voting action<select
        uiControl
        [(ngModel)]="roundSource"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="">Choose a voting action</option>
        @for (n of rounds; track n.id) {
          @if (n.id !== nodeId) {
            <option [value]="n.id">{{ label(n.id) }}</option>
          }
        }
        <option [value]="nodeId">Conduct the vote on this step</option>
      </select></label
    >
  }
  @if (configureRound) {
    <label
      >Voting population<select
        uiControl
        [(ngModel)]="populationSource"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="">Choose a population action</option>
        @for (n of populations; track n.id) {
          @if (n.id !== nodeId) {
            <option [value]="n.id">{{ label(n.id) }}</option>
          }
        }
        <option [value]="nodeId">Define the population on this step</option>
      </select></label
    >
  }
  @if (configurePopulation) {
    <label
      >Population comes from<select
        uiControl
        [(ngModel)]="sourceKind"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="manual">People selected by staff</option>
        <option value="hearing-panel">This workflow's hearing panel</option>
      </select></label
    >
    @if (sourceKind === "hearing-panel") {
      @if (hears.length > 1) {
        <label
          >Hearing<select
            uiControl
            [(ngModel)]="hearingField"
            [disabled]="disabled"
            (ngModelChange)="edit()"
          >
            <option value="">Choose the hearing source</option>
            @for (f of hears; track f.key) {
              <option [value]="f.key">{{ f.label }}</option>
            }
          </select></label
        >
      } @else {
        <p>
          Uses the workflow's hearing automatically. Starting from a hearing
          supplies the actual record.
        </p>
      }
      <fieldset>
        <legend>Panel roles eligible to vote</legend>
        @for (role of roleChoices; track role[0]) {
          <label class="check"
            ><input
              type="checkbox"
              [checked]="roles.includes(role[0])"
              [disabled]="disabled"
              (change)="toggle('roles', role[0], $any($event.target).checked)"
            />{{ role[1] }}</label
          >
        }
      </fieldset>
      <p>
        Other panel roles remain visible but do not vote. Staff must resolve any
        unidentified members before confirming the population.
      </p>
    } @else {
      <p>
        Staff select actual people and confirm voting eligibility during the
        step.
      </p>
    }
  }
  @if (configureRound) {
    <label
      >Question put to the vote<input
        uiControl
        maxlength="1000"
        [(ngModel)]="question"
        [disabled]="disabled"
        (ngModelChange)="edit()"
    /></label>
    <label
      >How votes are captured<select
        uiControl
        [(ngModel)]="captureMode"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="personal">Members cast their own votes</option>
        <option value="recorded">Authorized staff record member votes</option>
        <option value="both">Either permitted method</option>
      </select></label
    >
    <label
      >Required participants<input
        uiControl
        type="number"
        min="1"
        max="256"
        step="1"
        [(ngModel)]="rules.quorumThreshold"
        [disabled]="disabled"
        (ngModelChange)="edit()"
    /></label>
    <label
      >Approval rule<select
        uiControl
        [(ngModel)]="rules.approvalRuleCode"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="">Choose a rule</option>
        <option value="strict_majority">Strict majority</option>
        <option value="unanimity">Unanimity</option>
      </select></label
    >
    <label
      >Approval denominator<select
        uiControl
        [(ngModel)]="rules.denominatorCode"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="">Choose a denominator</option>
        <option value="eligible_members">All eligible members</option>
        <option value="votes_cast">Approve and reject votes</option>
      </select></label
    >
    <label
      >Abstentions toward quorum<select
        uiControl
        [(ngModel)]="rules.abstentionQuorumCode"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="">Choose a rule</option>
        <option value="count">Count</option>
        <option value="exclude">Exclude</option>
      </select></label
    >
    <label
      >Tied approval and rejection votes<select
        uiControl
        [(ngModel)]="rules.tieCode"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      >
        <option value="">Choose a result</option>
        <option value="no_decision">No decision</option>
        <option value="reject">Reject</option>
      </select></label
    >
  }
  @if (deferred && provider !== "voting.population-confirmed") {
    <label class="check"
      ><input
        type="checkbox"
        [(ngModel)]="allMembers"
        [disabled]="disabled"
        (ngModelChange)="edit()"
      />Every eligible member must record a vote or abstention</label
    >
  }
  @if (provider === "workflow.quorum-evaluated") {
    <fieldset>
      <legend>Quorum outcomes permitting completion</legend>
      @for (outcome of outcomeChoices; track outcome) {
        <label class="check"
          ><input
            type="checkbox"
            [checked]="outcomes.includes(outcome)"
            [disabled]="disabled"
            (change)="toggle('outcomes', outcome, $any($event.target).checked)"
          />{{ outcome.replaceAll("_", " ") }}</label
        >
      }
    </fieldset>
  }
  <p *ngIf="error" class="error" role="alert">{{ error }}</p>
  @if (code !== "voting.population") {
    <label class="check"
      ><input
        type="checkbox"
        [(ngModel)]="routeOutcomes"
        [disabled]="disabled || existingRouter"
        (ngModelChange)="edit()"
      />Route the step by the recorded quorum outcome</label
    >
    @if (routeOutcomes) {
      <p>
        Complete step evaluates the recorded result again before following its
        destination. Select earlier work steps for explicit return visits.
      </p>
      @for (outcome of outcomeChoices; track outcome) {
        <label
          >{{ outcome.replaceAll("_", " ") }} destination<select
            uiControl
            [(ngModel)]="routes[outcome]"
            [disabled]="disabled"
            (ngModelChange)="edit()"
          >
            <option value="">Choose a destination</option>
            @for (n of document.nodes; track n.id) {
              @if (
                n.id !== nodeId &&
                (n.typeCode === "human_step" || n.typeCode === "terminal")
              ) {
                <option [value]="n.id">{{ label(n.id) }}</option>
              }
            }
          </select></label
        >
      }
    }
  }
  <button
    *ngIf="!deferred"
    uiButton
    type="button"
    [disabled]="disabled"
    (click)="save()"
  >
    Apply voting configuration
  </button>
</section>
